export function buildRealmPath(realm, path) {
    const cleanPath = path && path.startsWith('/') ? path.slice(1) : (path || '');
    return `/${realm}${cleanPath ? '/' + cleanPath : ''}`;
}
